import { Component, Input } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { UtilityService } from '../../../core/services/utility.service';

@Component({
  selector: 'app-search-select-modal',
  templateUrl: './search-select-modal.component.html',
  styleUrls: ['./search-select-modal.component.css']
})
export class SearchSelectModalComponent {
  @Input() bindLabel: string;
  @Input() bindValue: string;
  @Input() headerText: any;
  @Input() clearButtonText: string = 'Clear Value';
  @Input() saveButtonText: string = 'Save';
  @Input() cancelButtonText: string = 'Cancel';
  @Input() searchFunction: (args: string) => any[] | null = null;
  @Input() searchFunctionAsync: (args: string) => Promise<any[]> | null = null;
  items: any[] = [];
  @Input() selectedItem: any = null;


  constructor(
    private ngbActiveModal: NgbActiveModal,
    public utilityService: UtilityService
  ) { }

  search (event) {
    if (event != null && event.term.length > 2) {
      if (this.searchFunction != null) {
        this.items = this.searchFunction(event.term)
      } else if (this.searchFunctionAsync != null) {
        this.searchAsync(event);
      }
    }
  }

  async searchAsync (event) {
      this.searchFunctionAsync(event.term).then(result => {
        this.items = result;
      });
  }

  clearSearchField() {
    this.selectedItem = null;
    this.saveAndCloseModal();
  }

  saveAndCloseModal () {
    this.ngbActiveModal.close(this.selectedItem);
  };

  cancelAndCloseModal () {
    this.ngbActiveModal.close(undefined);
  };
}
